import Header from "../components/Header";
import { useState, useEffect } from "react";
import api from "../components/api";
import { Spinner, Badge, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faHistory } from '@fortawesome/free-solid-svg-icons';

const OrderDelivered = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get('/order_delivered')
            .then(response => {
                const data = response.data.OrderDelivered || [];
                // On filtre pour être sûr de n'avoir que les "Livrée"
                setOrders(data.filter(o => o.status === "Livrée"));
            })
            .catch(error => {
                setError("Impossible de récupérer l'historique.");
                console.error(error);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Header />

            <div className="container mt-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className="fw-bold text-dark">
                        <FontAwesomeIcon icon={faHistory} className="me-2 text-primary" />
                        Historique des Livraisons
                    </h1>
                    <Badge bg="success" pill className="px-3 py-2">
                        {orders.length} Commandes terminées
                    </Badge>
                </div>

                {loading ? (
                    <div className="text-center mt-5">
                        <Spinner animation="grow" variant="primary" />
                        <p className="mt-3 text-muted">Chargement de l'historique...</p>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger text-center shadow-sm">{error}</div>
                ) : (
                    <Card className="border-0 shadow-sm">
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="ps-4">#</th>
                                        <th>Client</th>
                                        <th>Articles & Descriptions</th>
                                        <th>Date & Heure</th>
                                        <th className="text-center">Total</th>
                                        <th>Localisation</th>
                                        <th className="text-center">Statut</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orders.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5 text-muted italic">
                                                Aucune commande livrée pour le moment.
                                            </td>
                                        </tr>
                                    ) : (
                                        orders.map((order, orderIndex) => (
                                            order.order_items.map((item, itemIndex) => (
                                                <tr key={`${order.id}-${item.id}`}>
                                                    {/* Affichage groupé : on ne montre le # et le nom qu'à la 1ère ligne de la commande */}
                                                    <td className="ps-4 text-muted fw-bold">
                                                        {itemIndex === 0 ? orderIndex + 1 : ""}
                                                    </td>
                                                    <td className="fw-semibold">
                                                        {itemIndex === 0 ? order.user?.name : ""}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-bold">{item.quantity}x {item.menu_item?.name}</span>
                                                            <small className="text-muted">{item.menu_item?.description}</small>
                                                        </div>
                                                    </td>
                                                    <td className="small">
                                                        {itemIndex === 0 ? new Date(order.created_at).toLocaleString('fr-FR', {
                                                            day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'
                                                        }) : ""}
                                                    </td>
                                                    <td className="text-center fw-bold text-primary">
                                                        {itemIndex === 0 ? `${order.total_price} FCFA` : ""}
                                                    </td>
                                                    <td>
                                                        {itemIndex === 0 && (
                                                            <span className="badge bg-secondary-subtle text-secondary border">
                                                                {order.localisation}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {itemIndex === 0 && (
                                                            <span className="text-success fw-bold small text-uppercase">
                                                                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                                                                {order.status}
                                                            </span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                )}
            </div>
        </>
    );
};

export default OrderDelivered;